export enum PlayerTabs {
    Videos,
    Details,
    Custom,
    AdditionVideos,
}